interface Config {
  baseUrl: string;
  apiUrl: string;
  encryptionkey?: string;
  PORT?: string;
}

const local: Config = {
  baseUrl: 'http://localhost:4073',
  apiUrl: 'http://localhost:4073/api/v1',
  PORT: '',
};

const staging: Config = {
  baseUrl: 'https://meanstack.smartdatainc.com:4094/',
  apiUrl: 'https://meanstack.smartdatainc.com:4094/api/v1',
  encryptionkey: '',
  PORT: '',
};

const production: Config = {
  baseUrl: 'https://api.calligent.com.au/',
  apiUrl: 'https://api.calligent.com.au/api/v1',
  encryptionkey: '',
  PORT: '80',
};

let envConfig: Config;

if (process.env.NODE_ENV === 'development') {
  envConfig = local;
} else if (process.env.NODE_ENV === 'none') {
  envConfig = staging;
} else if (process.env.NODE_ENV === 'production') {
  envConfig = production;
} else {
  envConfig = local;
}

export default envConfig;
